import config from '../../configs/config';
import { makeApiGatewayCall } from '../common/apiUtils';
const moment = require('moment');

interface ICustomFieldValue {
	Name: string;
	Value: string;
}

export const getAutomations = ({ page = 1, pageSize = 10, params }: { page?: number; pageSize?: number; params?: string }) => {
	return makeApiGatewayCall(config.automationsService.getAutomations(page, pageSize, params), 'get');
};

export const getAutomationsByFilters = ({ page = 1, pageSize = 99, filters }: { page?: number; pageSize?: number; filters: any }) => {
	return makeApiGatewayCall(config.automationsService.getAutomationsByFilters(page, pageSize), 'post', filters);
};

export const changeAutomationStatus = ({ automationId, status }: { automationId: string; status: boolean }) => {
	const url = status ? config.automationsService.unpauseAutomation(automationId) : config.automationsService.pauseAutomation(automationId);

	return makeApiGatewayCall(url, 'put');
};

export const triggerAutomation = ({
	automationId,
	selectedItems,
	mailingListId,
}: {
	automationId: string;
	selectedItems: {
		Email: string;
		Name: string;
		CustomFields: ICustomFieldValue[];
		Id: string;
		Tags: string[];
	}[];
	mailingListId: string;
}) => {
	const url = config.automationsService.triggerAutomation(automationId);

	const payload = {
		AutomationId: automationId,
		Event: {
			EventName: 'TRIGGERED_AUTOMATION',
			Timestamp: moment().format(),
			ContactContext: {
				Id: selectedItems[0].Id,
				Name: selectedItems[0].Name,
				MailingListId: mailingListId,
				CustomFields: selectedItems[0].CustomFields,
				EmailAddress: selectedItems[0].Email,
				ContactToken: selectedItems[0].Email,
				MailingListMemberId: selectedItems[0].Id,
				Tags: selectedItems[0].Tags,
				ContactType: 0,
			},
		},
	};

	return makeApiGatewayCall(url, 'put', payload);
};

export const triggerAutomationForMany = ({
	automationId,
	selectedItems,
	mailingListId,
}: {
	automationId: string;
	selectedItems: {
		Email: string;
		Name: string;
		CustomFields: ICustomFieldValue[];
		Id: string;
		Tags: string[];
	}[];
	mailingListId: string;
}) => {
	const url = config.automationsService.triggerAutomationForMany(automationId);

	const payload = {
		AutomationId: automationId,
		Events: selectedItems.map((item) => ({
			EventName: 'TRIGGERED_AUTOMATION',
			Timestamp: moment().format(),
			ContactContext: {
				Id: item.Id,
				Name: item.Name,
				MailingListId: mailingListId,
				CustomFields: item.CustomFields,
				EmailAddress: item.Email,
				ContactToken: item.Email,
				MailingListMemberId: item.Id,
				Tags: item.Tags,
				ContactType: 0,
			},
		})),
	};

	return makeApiGatewayCall(url, 'put', payload);
};
